module.exports = __webpack_public_path__ + "img/googleplay.cce88d48.png";